import { formatDate, renderAmount, SupportCheckoutChargeRefund } from '@enter/core';
import React from 'react';
import * as S from './billing-timeline-table.styles';

interface IRefundDetailProps {
    refund: SupportCheckoutChargeRefund;
}

export const RefundDetail: React.FunctionComponent<IRefundDetailProps> = (
    props: IRefundDetailProps,
): React.ReactElement => {
    const { refund } = props;
    const { id, memo, refundedAmount, refundedFeeAmount, refundDate } = refund;

    return (
        <S.Table key={id} expand={true}>
            <S.TBody>
                <S.TR>
                    <S.TH>Date</S.TH>
                    <S.TD>{formatDate(refundDate, 'MMM d, yyyy')}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Refund Amount</S.TH>
                    <S.TD>{renderAmount(refundedAmount)}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Refund Fee Amount</S.TH>
                    <S.TD>{renderAmount(refundedFeeAmount)}</S.TD>
                </S.TR>
                <S.TR>
                    <S.TH>Memo</S.TH>
                    <S.TD>{memo || '--'}</S.TD>
                </S.TR>
            </S.TBody>
        </S.Table>
    );
};
